import { IEnvironment } from './ienvironment';

export const environment: IEnvironment = {
  production: true,
  applicationInsights: {
    instrumentationKey: '9424e62d-ba59-404c-bd21-f6da319e105d',
    enableDebug: false,
    maxAjaxCallsPerView: 10
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.prod.ts